// src/pages/pedidos/TipoEntregaCad.js
import React, { useEffect, useState } from 'react';

import { TipoEntrega } from '../../models/pedidos/TipoEntrega';
import { useTipoEntrega } from '../../contexts/pedidos/TipoEntregaContext';
import TipoEntregaSearch from './TipoEntregaSearch';
import Input from '../../components/input/Input';
import InputCheck from '../../components/input/InputCheck';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const TipoEntregaCad = ({ show, onHide }) => {
    const { tiposEntrega, addTipoEntrega, updateTipoEntrega, deleteTipoEntrega } = useTipoEntrega();
    const [tipoEntrega, setTipoEntrega] = useState(new TipoEntrega());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setTipoEntrega(new TipoEntrega());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage('Selecione um Tipo de Entrega para editar!');
            return;
        }

        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!tipoEntrega?.id) {
            showMessage('Selecione um Tipo de Entrega para excluir!');
        } else {
            const resposta = await showYesNo('Deseja excluir o tipo de entrega selecionado?');

            if (resposta) {
                await deleteTipoEntrega(tipoEntrega.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!tipoEntrega.descricao) {
                showMessage('Informe uma descrição para o tipo de entrega!');
                return;
            }

            if (!tipoEntrega.id) {
                await addTipoEntrega(tipoEntrega);
            } else {
                await updateTipoEntrega(tipoEntrega);
            }

            handleNovo();
        } catch (error) {
            console.error('Erro ao gravar dados: ', error);
        }
    };

    const handleExit = () => {
        const tipoSel = tiposEntrega.find(t => t.id.toString() === tipoEntrega?.id?.toString());

        if (tipoSel) {
            setTipoEntrega(tipoSel);
            handleEditar(tipoEntrega?.id);
        } else {
            setTipoEntrega(new TipoEntrega());
        }
    };

    const handleSelectTipoEntrega = (tipoSel) => {
        setTipoEntrega(tipoSel);
        setShowSearchModal(false);

        if (tipoSel) {
            handleEditar(tipoSel.id);
        } else {
            setTipoEntrega(new TipoEntrega());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Novo Tipo de Entrega' : 'Alterar Tipo de Entrega'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={tipoEntrega.id || ''}
                            onChange={(e) => setTipoEntrega({ ...tipoEntrega, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />

                        <Input
                            label="Descrição"
                            value={tipoEntrega.descricao || ''}
                            onChange={(e) => setTipoEntrega({ ...tipoEntrega, descricao: e.target.value })}
                            size={250}
                            autoFocus
                        />

                        <InputCheck
                            id="temTaxaEntrega"
                            label="Tem Taxa de Entrega"
                            checked={tipoEntrega.temTaxaEntrega}
                            onChange={(e) => setTipoEntrega({ ...tipoEntrega, temTaxaEntrega: e.target.checked })}
                        />

                        <InputCheck
                            id="exibeApp"
                            label="Exibe no App"
                            checked={tipoEntrega.exibeApp}
                            onChange={(e) => setTipoEntrega({ ...tipoEntrega, exibeApp: e.target.checked })}
                        />
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <TipoEntregaSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectTipoEntrega={handleSelectTipoEntrega}
            />
        </ModalContainer>
    );
};

export default TipoEntregaCad;
